var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "15 15 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/video/minimize/20",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M35,15 L28.1534164,15 C27.5328522,15 27.0297856,15.4742753 27.0297856,16.0593227 L27.0297856,22.1991796 L28.4259602,22.1991796 L28.4259602,16.3424019 L35,16.3424019 L35,15 Z",
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(31.014893, 18.599590) scale(1, -1) translate(-31.014893, -18.599590) "
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M35,28 L28.1534164,28 C27.5328522,28 27.0297856,28.4742753 27.0297856,29.0593227 L27.0297856,35.1991796 L28.4259602,35.1991796 L28.4259602,29.3424019 L35,29.3424019 L35,28 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M22.9702144,15 L16.1236308,15 C15.5030667,15 15,15.4742753 15,16.0593227 L15,22.1991796 L16.3961746,22.1991796 L16.3961746,16.3424019 L22.9702144,16.3424019 L22.9702144,15 Z",
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(18.985107, 18.599590) scale(-1, -1) translate(-18.985107, -18.599590) "
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M22.9702144,28 L16.1236308,28 C15.5030667,28 15,28.4742753 15,29.0593227 L15,35.1991796 L16.3961746,35.1991796 L16.3961746,29.3424019 L22.9702144,29.3424019 L22.9702144,28 Z",
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(18.985107, 31.599590) scale(-1, 1) translate(-18.985107, -31.599590) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.f99f60e7e511511744393a180f5eba92.svg";
export { ForwardRef as ReactComponent };